<template>
    <div class="card box-filters container">

        <p class="text-uppercase h5 hidden-sm-down">Filtrer par</p>

        <FilterValue
                v-for="filter of getAttributesGroup()"
                :parentFilter="filter"
                :key="'attribute_' +filter.id"
                :type="getTypeAttributeGroup()"
        ></FilterValue>

        <FilterValue
                v-for="filter of getFeatures()"
                :parentFilter="filter"
                :key="'feature_' +filter.id"
                :type="getTypeFeature()"
        ></FilterValue>
    </div>
</template>


<script>
    import FilterValue from './FilterValue'
    import {mapGetters} from 'vuex'
    import * as types from '../store/types';
    import * as type from '../api/type';


    export default {
        name: 'Filters',
        components: {
            FilterValue,
        },
        methods: {
            getTypeFeature() {
                return type.getTypeFilterFeature();
            },
            getTypeAttributeGroup() {
                return type.getTypeFilterAttribute();
            },
            ...mapGetters({
                getAttributesGroup: types.GET_FILTER_ATTRIBUTES,
                getFeatures: types.GET_FILTER_FEATURES,
                getFilter: types.GET_FILTER_BY_ID
            })
        }
    }
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Filters.vue